
import { DesktopHome } from "@/components/DesktopHome";

// /inicio → sempre mostra a home normal (hero, jornada, etc.)
// O linktree mobile fica na rota "/" — ver App.tsx
const Index = () => <DesktopHome />;

export default Index;
